module.exports = __webpack_public_path__ + "img/bg1.7ea102e9.png";